(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["quantity-discounts-window"] && !Shopify.designMode) return;
  try {
    if (!window.customElements.get('quantity-discounts')) {
    class QuantityDiscounts extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        this.dialog = this.querySelector('.qd__dialog');
        this.productForm();
        this.cards = Array.from(this.querySelectorAll('[data-tier]'));
        this.basePrice = Number(this.dataset.basePrice || 0);
        this.currency = this.dataset.currency;
        this.locale = this.dataset.locale || document.documentElement.lang || 'en';
        this.applyingTier = false;
        window.__qdOfferQuantities ||= new Map();
        this.updateCurrencyIcon();
        this.ensureButtonContrast();

        this.addEventListener('click', (event) => this.handleClick(event), { signal: this.controller.signal });
        this.dialog?.addEventListener('click', (event) => {
          if (event.target === this.dialog) this.dialog.close();
        }, { signal: this.controller.signal });
        this.addEventListener('keydown', (event) => this.handleKeydown(event), { signal: this.controller.signal });
        document.addEventListener('change', (event) => this.handleFormChange(event), { signal: this.controller.signal });
        document.addEventListener('input', (event) => this.handleFormChange(event), { signal: this.controller.signal });

        const rememberedQuantity = window.__qdOfferQuantities.get(this.id);
        const rememberedCard = this.cards.find((card) => Number(card.dataset.qty) === Number(rememberedQuantity));
        const initialCard = rememberedCard || this.cards.find((card) => card.getAttribute('aria-checked') === 'true') || this.cards[0];
        if (initialCard) {
          this.selectCard(initialCard, true);
          if (!this.form) requestAnimationFrame(() => {
            if (this.isConnected && this.selectedCard) this.setFormQuantity(Number(this.selectedCard.dataset.qty));
          });
        }
        else this.renderEstimate(1, 0, true);
      }

      disconnectedCallback() {
        this.controller?.abort();
      }

      updateCurrencyIcon() {
        const icon = this.querySelector('[data-currency-symbol]');
        if (!icon || !this.currency) return;
        try {
          const currencyPart = new Intl.NumberFormat(this.locale, {
            style: 'currency',
            currency: this.currency,
            currencyDisplay: 'symbol'
          }).formatToParts(0).find((part) => part.type === 'currency');
          if (currencyPart?.value) icon.textContent = currencyPart.value;
        } catch (error) {
          icon.textContent = this.currency;
        }
      }

      ensureButtonContrast() {
        const context = document.createElement('canvas').getContext('2d');
        if (!context) return;
        const rgb = (value) => {
          context.fillStyle = '#000000';
          context.fillStyle = value;
          const normalized = context.fillStyle;
          if (normalized.startsWith('#')) {
            let hex = normalized.slice(1);
            if (hex.length === 3) hex = hex.split('').map((part) => part + part).join('');
            if (hex.length !== 6) return null;
            return [0, 2, 4].map((index) => Number.parseInt(hex.slice(index, index + 2), 16));
          }
          const channels = normalized.match(/[\d.]+/g);
          return channels?.length >= 3 ? channels.slice(0, 3).map(Number) : null;
        };
        const luminance = (channels) => channels.map((channel) => {
          const value = channel / 255;
          return value <= 0.04045 ? value / 12.92 : ((value + 0.055) / 1.055) ** 2.4;
        }).reduce((sum, value, index) => sum + value * [0.2126, 0.7152, 0.0722][index], 0);
        const contrastRatio = (first, second) => {
          const firstLuminance = luminance(first);
          const secondLuminance = luminance(second);
          return (Math.max(firstLuminance, secondLuminance) + 0.05) / (Math.min(firstLuminance, secondLuminance) + 0.05);
        };

        const styles = getComputedStyle(this);
        let backgroundValue = styles.getPropertyValue('--qd-button').trim();
        let background = rgb(backgroundValue);
        const foreground = rgb(getComputedStyle(this).getPropertyValue('--qd-button-text').trim());
        const surface = rgb(styles.getPropertyValue('--qd-surface').trim());
        const accentValue = styles.getPropertyValue('--qd-accent').trim();
        const accent = rgb(accentValue);
        if (!background) return;
        if (surface && contrastRatio(background, surface) < 1.4) {
          backgroundValue = accent && contrastRatio(accent, surface) >= 1.4 ? accentValue : '#171923';
          this.style.setProperty('--qd-button', backgroundValue);
          background = rgb(backgroundValue);
        }
        if (!foreground) return;
        if (contrastRatio(background, foreground) < 4.5) {
          const backgroundLuminance = luminance(background);
          const blackContrast = (backgroundLuminance + 0.05) / 0.05;
          const whiteContrast = 1.05 / (backgroundLuminance + 0.05);
          this.style.setProperty('--qd-button-text', blackContrast >= whiteContrast ? '#171923' : '#FFFFFF');
        }
      }

      handleClick(event) {
        const openButton = event.target.closest('[data-open-modal]');
        if (openButton && this.contains(openButton)) {
          this.dialog?.showModal();
          return;
        }

        const closeButton = event.target.closest('[data-close-modal]');
        if (closeButton && this.contains(closeButton)) {
          this.dialog?.close();
          return;
        }

        const card = event.target.closest('[data-tier]');
        if (card && this.contains(card)) {
          this.selectCard(card, true);
          return;
        }

        const applyButton = event.target.closest('[data-apply-offer]');
        if (applyButton && this.contains(applyButton) && !applyButton.disabled && this.productForm()) {
          this.dialog?.close();
          const submitter = this.form.querySelector('button[type="submit"], input[type="submit"]');
          if (this.form.requestSubmit) this.form.requestSubmit(submitter || undefined);
          else this.form.submit();
        }
      }

      handleKeydown(event) {
        const launcher = event.target.closest('[data-open-modal]');
        if (launcher && this.contains(launcher) && (event.key === 'Enter' || event.key === ' ')) {
          event.preventDefault();
          this.dialog?.showModal();
          return;
        }

        const card = event.target.closest('[data-tier]');
        if (!card || !this.contains(card)) return;
        const forward = this.dir === 'rtl' ? 'ArrowLeft' : 'ArrowRight';
        const backward = this.dir === 'rtl' ? 'ArrowRight' : 'ArrowLeft';
        let nextIndex = this.cards.indexOf(card);
        if (event.key === forward || event.key === 'ArrowDown') nextIndex = (nextIndex + 1) % this.cards.length;
        else if (event.key === backward || event.key === 'ArrowUp') nextIndex = (nextIndex - 1 + this.cards.length) % this.cards.length;
        else return;
        event.preventDefault();
        this.cards[nextIndex].focus();
        this.selectCard(this.cards[nextIndex], true);
      }

      handleFormChange(event) {
        const form = this.productForm();
        if (this.applyingTier || !form || event.target.form !== form || event.target.name !== 'quantity') return;
        const quantity = Number(event.target.value);
        if (!Number.isFinite(quantity) || quantity < 1) return;
        const matchingCard = this.cards.find((card) => Number(card.dataset.qty) === quantity);
        if (matchingCard) this.selectCard(matchingCard, false);
        else {
          this.clearSelection();
          this.renderEstimate(quantity, 0, true);
        }
      }

      selectCard(card, syncQuantity) {
        this.selectedCard = card;
        this.cards.forEach((offer) => {
          const selected = offer === card;
          offer.classList.toggle('is-selected', selected);
          offer.setAttribute('aria-checked', String(selected));
          offer.tabIndex = selected ? 0 : -1;
        });
        const quantity = Number(card.dataset.qty);
        const discount = Number(card.dataset.discount || 0);
        if (syncQuantity) this.setFormQuantity(quantity);
        this.renderEstimate(quantity, discount, false);
      }

      clearSelection() {
        this.selectedCard = null;
        this.cards.forEach((offer) => {
          offer.classList.remove('is-selected');
          offer.setAttribute('aria-checked', 'false');
          offer.tabIndex = -1;
        });
        if (this.cards[0]) this.cards[0].tabIndex = 0;
        const label = this.querySelector('[data-estimate-label]');
        if (label) label.textContent = this.dataset.customQuantityText || label.textContent;
      }

      quantityFields() {
        const form = this.productForm();
        if (!form) return [];
        return Array.from(document.querySelectorAll('input[name="quantity"]')).filter((field) => field.form === form);
      }

      setFormQuantity(quantity) {
        const form = this.productForm();
        if (!form) return;
        let fields = this.quantityFields();
        if (fields.length === 0) {
          const input = document.createElement('input');
          input.type = 'hidden';
          input.name = 'quantity';
          form.append(input);
          fields = [input];
        }
        this.applyingTier = true;
        fields.forEach((field) => {
          field.value = String(quantity);
          field.dispatchEvent(new Event('input', { bubbles: true }));
        });
        this.applyingTier = false;
      }

      currentQuantity() {
        const field = this.quantityFields()[0];
        return Math.max(1, Number(field?.value || this.dataset.fallbackQuantity || 1));
      }

      productForm() {
        if (!this.form || !this.form.isConnected) this.form = document.getElementById(this.dataset.formId);
        return this.form;
      }

      refreshCardPrices() {
        this.cards.forEach((card) => {
          const quantity = Number(card.dataset.qty);
          const discount = Number(card.dataset.discount || 0);
          const gross = this.basePrice * quantity;
          const saving = Math.round(gross * discount / 100);
          const total = gross - saving;
          const totalElement = card.querySelector('[data-tier-total]');
          const savingElement = card.querySelector('[data-tier-saving]');
          if (totalElement) totalElement.textContent = this.formatMoney(total);
          if (savingElement) {
            savingElement.textContent = saving > 0 ? `${this.savingLabel()} ${this.formatMoney(saving)}` : this.formatMoney(0);
            savingElement.classList.toggle('qd__offer-saving--empty', saving <= 0);
          }
        });
      }

      renderEstimate(quantity, discount, customQuantity) {
        const safeQuantity = Math.max(1, Number(quantity) || 1);
        window.__qdOfferQuantities.set(this.id, safeQuantity);
        const gross = this.basePrice * safeQuantity;
        const saving = Math.round(gross * discount / 100);
        const totalElement = this.querySelector('[data-estimate-total]');
        const savingElement = this.querySelector('[data-estimate-saving]');
        const quantityElement = this.querySelector('[data-estimate-quantity]');
        const label = this.querySelector('[data-estimate-label]');
        if (totalElement) totalElement.textContent = this.formatMoney(gross - saving);
        if (savingElement) {
          savingElement.textContent = saving > 0 ? `${this.savingLabel()} ${this.formatMoney(saving)}` : '';
          savingElement.hidden = saving <= 0;
        }
        if (quantityElement) quantityElement.textContent = `${this.formatNumber(safeQuantity)} ${this.quantityLabel()}`;
        if (label && !customQuantity) label.textContent = this.totalLabel();
        this.refreshCardPrices();
      }

      formatMoney(amount) {
        try {
          return new Intl.NumberFormat(this.locale, { style: 'currency', currency: this.currency }).format(amount / 100);
        } catch (error) {
          return `${(amount / 100).toFixed(2)} ${this.currency || ''}`.trim();
        }
      }

      formatNumber(value) {
        return new Intl.NumberFormat(this.locale, { maximumFractionDigits: 0 }).format(value);
      }

      text(name, fallback) {
        return this.getAttribute(`data-${name}`) || fallback;
      }

      totalLabel() { return this.text('total-text', 'Estimated total'); }
      savingLabel() { return this.text('saving-text', 'You save'); }
      quantityLabel() { return this.text('quantity-text', 'items'); }
    }

    window.customElements.define('quantity-discounts', QuantityDiscounts);
  }
  } catch(e) { console.error(e); }
})();

})();
